module.exports = __webpack_public_path__ + "img/menu-change-email.08c920e7.svg";